import "../../CommonImports";
import "../../Core/core.css";
import * as React from "react";
import { Observer } from '../../Observer';
import { MoreButton } from "../Menu/MoreButton";
import { ResizeGroupContext } from "./ResizeGroup";
export class OverflowButton extends React.Component {
    constructor() {
        super(...arguments);
        this.moreButton = React.createRef();
    }
    render() {
        return (React.createElement(ResizeGroupContext.Consumer, null, (resizeGroupContext) => {
            return (React.createElement(Observer, { menuItems: resizeGroupContext.overflowItems }, (props) => props.menuItems && props.menuItems.length > 0 ? (React.createElement(MoreButton, Object.assign({ contextualMenuProps: {
                    menuProps: { id: "overflow-menu", items: props.menuItems },
                    className: this.props.menuClassName
                }, ref: this.moreButton }, this.props))) : (React.createElement("div", { className: "overflow-button-empty-div" }))));
        }));
    }
    focus() {
        if (this.moreButton.current) {
            this.moreButton.current.focus();
        }
    }
}
